import React, {FC, memo} from 'react';
import {FlatList, ScrollView, StyleSheet, Text, View} from 'react-native';
import {getDescriber} from '../../screens/home/descriptor/DescriptorType';
import {ProductData} from '../../../types/serverTypes/Account';
import Styles from '../../Styles';

interface RecommendationsBlockProps {
  products: ProductData[];
  onAddPress?: (product: ProductData) => void;
  onItemPressed: (product: ProductData) => void;
}

export const RecommendationsBlock: FC<RecommendationsBlockProps> = memo(
  ({products, onItemPressed}) => {
    const renderItem = ({item, index}: {item: ProductData; index: number}) => {
      return getDescriber()?.recommendationsBlockRenderItem({
        item,
        index,
        isLastItem: index === products.length - 1,
        isFirstItem: index === 0,
        onMenuItemPress: onItemPressed,
      });
    };

    return (
      <View style={styles.container}>
        <Text style={styles.title}>You might like this:</Text>
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <FlatList
            data={products}
            renderItem={renderItem}
            horizontal
            keyExtractor={(item) => item.productId}
          />
        </ScrollView>
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: Styles.Spacing.m3,
  },
  title: {
    fontFamily: Styles.FontFamily.aeonikRegular,
    fontWeight: '700',
    fontSize: 16,
    lineHeight: 19,
    color: Styles.black,
    marginBottom: Styles.Spacing.m3,
  },
});
